<template>
    <div>
        <Down v-if="isWeixins()" />
        <div :class="{'daily-list-panel':true,'iswx':isWeixins(),'isvip':vip == 0,'bigDataDark': isDark}">
            <div v-if="$route.query.h" class="tab-test" :style="{'width': '100%','height': $route.query.h /100 + 'rem'}"></div>
            <div :class="{'daily-pro':true,'intelligence':false}">
                <Header :behavior="behavior" :type="type" :info="info" :vip="vip" :buyInfo="buyInfo" @goPay="goPay" />
            </div>
             <!-- tab切换 -->
            <div class="ai-tab">
                <div @click="changeTab(1)">
                    <span :class="tab == 1 ? 'active' : ''">历史分析<em></em></span>
                </div>
                <div  @click="changeTab(2)">
                    <span :class="tab == 2 ? 'active' : ''">今日分析<em></em></span>
                </div>
            </div>
            <!-- 今日推荐总概 -->
            <div :class="{'cold-summary':true, 'clearfloat':true, 'none': tab == 1 || (info.status==-1 || info.status == 0 || info.status == 3)}">
                <div class="summary-txt">推荐总数:{{list && list.length}}场 {{modelupdatetime}}分钟前更新</div>
                <div :class="{'summary-btn':true,'fl-r':true}">
                    <div :class="sort == 1? 'active':''" @click="changeSort(1)">按时间</div>
                    <div :class="sort == 2? 'active':''" @click="changeSort(2)">按认可度</div>
                </div>
            </div>
            <!-- 日历切换 -->
            <div :class="{'daily-calendar':true,'none': tab == 2}">
                <template v-if="getCookies('JH') && info.status != 0 && info.status != 3 && tomorrowNumber  > 0">
                    <i class="matchs-line"></i><b>预告明日{{tomorrowNumber}}场比赛</b>
                </template>
                <div :class="{'matchs-num':true,'none': tab == 2 && (info.status == 0 || info.status == -1 || info.status == 3)}"><span>今日</span>{{selectTime}}(共{{list && list.length}}场) <i :class="{'icon':true,'i_calendar':true}" @click="showCalendar = true"></i></div>
            </div>
             <!-- 模型列表 -->
            <div :class="{'daily-list': true, 'bg1': list&&list.length != 0 && (tab==1 || (tab == 2 && info.status != -1 && info.status != 0 && info.status != 3) || (tab == 2 && vip == 1)), 'none': loading}">
                <div class="daily-package daily-2 nobg">
                    <ul>
                        <li class="daily-package-item no1">
                            <template v-if="tab == 2 && (info.status == -1 ||info.status == 0 || info.status == 3) && vip == 0">
                                <div class="daily-find">
                                    <i class="daily-no-find"></i>
                                    <p>您目前暂未订购该模型，仅可查看往日推荐内容，<span class="gonow" @click="goPay(false)">赶快去订购吧！</span></p>
                                </div>
                            </template>
                            <template v-else-if="list">
                                <template v-if="list.length > 0">
                                    <van-list
                                    v-model="pageLoading"
                                    :finished="finished"
                                    finished-text="没有更多了"
                                    @load="getList"
                                    >
                                        <template v-for="(item,index) in list">
                                            <div :key="index" class="package-dec dec_1" @click="goDataModelDetail(item)">
                                                <div class="package-team info">
                                                    <span class="league" :style="{color: item.sclass_color}">{{item.sclass_name}}</span><span class="time">{{item.match_time.replace(/(^\d{4}\-|\:\d{2}$)/g, "").replace(/\-(\d{2})/g, "月$1日")}}</span>
                                                </div>
                                                <div class="match-team-result">
                                                    <div class="match-col">
                                                        <div class="wave-team-logo"><img :src="item.home_logo || 'https://s.jihaimall.com/h5/image/home_new.png'" /></div>
                                                        <div class="team-name">{{item.home_team}}</div>
                                                    </div>
                                                    <template v-if="item.match_state == -1">
                                                        <div class="match-score">
                                                            <div class="xbc">{{item.home_score}}:{{item.guest_score}}</div>
                                                            <div class="sbc">({{item.home_half_score}}:{{item.guest_half_score}})</div>
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        <div class="match-vs-odds">VS</div>
                                                    </template>
                                                    <div class="match-col">
                                                        <div class="wave-team-logo"><img :src="item.guest_logo || 'https://s.jihaimall.com/h5/image/guest_new.png'" /></div>
                                                        <div class="team-name">{{item.guest_team}}</div>
                                                    </div>
                                                    <div></div>
                                                    <template v-if="item.match_state == -1">
                                                        <template v-if="type == 15">
                                                            <RenderChar :item="item" :isDark="isDark"/>
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <RenderChar :item="item" :isDark="isDark"/>
                                                    </template>
                                                </div>
                                            </div>
                                        </template>
                                    </van-list>
                                </template>
                                <template v-else>
                                    <div class="daily-find">
                                        <i class="daily-no-find"></i>
                                        <p>暂无数据!</p>
                                    </div>
                                </template>
                            </template>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 日历切换 -->
            <Calendar
                :show.sync="showCalendar"
                :start_time="start_time"
                :end_time="end_time"
                :current_time="current_time"
                @callback="updateDailyDate"
            />
            <!-- vip开通入口 -->
            <template v-if="vip == 0">
                <VipEnter :saveMoney="saveMoney" :isDark="isDark"></VipEnter>
            </template>
            <div class="placehodler"></div>
        </div>
    </div>
</template>

<script>
import Down from "../../components/programme/appdown.vue"
import Header from "../../components/datamodel/common/headerCard.vue"
import { isWeiXin, urlQuery, setTitle, formatDate, getCookie, isJHApp, isJHAppios, getAppV, getVersionNotApp, isStorepack, isHiscores, doLogin } from "../../utils/base"
import jsbridg from '../../utils/jsbridg'
import mutil from "../../utils/mutil"
import { getDataTypeListApi, getColdHisApi, getForwardApi, iosIsAutoPay } from "../../api/model"
import RenderChar from "../../components/datamodel/common/renderSvg.vue"
import Calendar from "../../components/datamodel/common/calendar.vue"
import VipEnter from "../../components/datamodel/common/vipEnter.vue"
import { Dialog } from 'vant';
export default {
    name: "outOfThe",
    components: {
        Down,
        Header,
        RenderChar,
        Calendar,
        VipEnter,
        [Dialog.Component.name]: Dialog.Component
    },
    data () {
        return {
            loading: false,
            type: this.$route.query.type || 15,
            tab: 1, // 1历史推荐；2今日推荐
            sort: 1, // 1按时间；2按认可度
            showCalendar: false, // 显示日历
            onlineIsAuto: 0, // 是否自动续费
            noLogin: 0, // 是否登录
            today: [],
            tomorrowNumber: 0, // 明天预告场次数
            current_time: "",
            daytxt: "",
            start_time: "",
            end_time: "",
            selectTime: "",
            behavior: 0, // 顶部判断
            buyInfo: {}, // 购买人数
            info: {},
            vip: null, // 是否会员
            saveMoney: null, // 立省x元
            list: [], // 列表
            page: 1,
            pageLoading: false,
            finished: false,
            modelupdatetime: "" // 推荐总数刷新时间
        }
    },
    computed: {
        isDark () {
            return this.$store.state.common.isDark
        }
    },
    created () {
        this.topCardInformation();
        this.iosIsAutoPay();
    },
    methods: {
        getList () {
            this.page++;
            if (this.tab === 1) {
                this.historyRecommendList(this.selectTime);
            } else {
                this.todayRecommendList();
            }
        },
        // 顶部信息接口
        async topCardInformation () {
            setTitle(mutil.dailyMap[this.type + '']);
            const data = await getDataTypeListApi({
                type: this.type,
                tab: 'r'
            })
            // eslint-disable-next-line eqeqeq
            if (data && data.errno === 0) {
                // eslint-disable-next-line no-redeclare
                var datas = data.data;
                // 获取当前时间
                const _now = this.getCurrentTime();
                this.today = datas.todayData;
                this.tomorrowNumber = datas.tomorrowDataNum;
                this.current_time = _now || datas.curDate;
                this.start_time = _now;
                this.end_time = _now;
                this.selectTime = _now;
                this.daytxt = datas.day;
                // 购买信息
                this.buyInfo = {
                    total: data.buy_info.total,
                    avatar: data.buy_info.avatar
                }
                // 模型信息
                this.info = data.info;
                this.vip = data.vip.vip_big_use;
                this.saveMoney = (data.vip.text ? data.vip.text.price : null);
                this.loading = false;
                // eslint-disable-next-line eqeqeq
                if (this.info.status == 0 || this.info.status == -1 || this.info.status == 3) {
                    this.tab = 1;
                    this.historyRecommendList();
                } else {
                    this.tab = 2;
                    this.sort = 1;
                    this.todayRecommendList();
                }
            }
        },
        // 历史推荐列表
        async historyRecommendList (_time) {
            const hisUrl = '/data/oa/zq/analy/score/his';
            const hisJsons = {
                day_time: _time || '',
                page: this.page
            }
            const data = await getColdHisApi(hisJsons, hisUrl)
            if (data && data.errno === 0) {
                // eslint-disable-next-line eqeqeq
                if (data.data && data.data.length > 0) {
                    this.list = this.list.concat([], data.data);
                    this.loading = false;
                    this.$nextTick(() => {
                        this.svgCircle();
                    })
                    this.pageLoading = false
                } else {
                    this.finished = true;
                    this.pageLoading = false
                }
            }
        },
        // 今日推荐列表
        async todayRecommendList (_order) {
            const forwardJsons = {
                method: 'data/oa/zq/analy/score/schedule',
                data_type: 15,
                page: this.page,
                order: _order || ''
            }
            const data = await getForwardApi(forwardJsons)
            if (data && data.errno === 0) {
                const datas = data.data;
                if (datas.result && datas.result.length > 0) {
                    this.list = this.list.concat([], datas.result);
                    this.modelupdatetime = datas.minutes || "";
                    const _now = this.getCurrentTime();
                    this.selectTime = _now;
                    this.current_time = _now;
                    this.loading = false;
                    this.$nextTick(() => {
                        this.svgCircle();
                    })
                    this.pageLoading = false
                } else {
                    this.finished = true;
                    this.pageLoading = false
                }
            }
        },
        // 检查ios商城包是否自动续费
        async iosIsAutoPay () {
            const data = await iosIsAutoPay({ type: 15 })
            if (data.errno * 1 === 0) {
                this.onlineIsAuto = false;
            } else if (data.errno * 1 === 282) {
                this.onlineIsAuto = true;
            } else if (data.errno * 1 === -1) {
                this.noLogin = true;
            }
        },
        // 切换一级tab
        changeTab (num) {
            this.loading = true;
            this.tab = num;
            this.page = 1;
            this.finished = false;
            this.list = [];
            if (num === 1) {
                this.historyRecommendList();
            } else {
                this.todayRecommendList();
            }
        },
        // 切换排序
        changeSort (num) {
            this.loading = true;
            var order = "";
            if (num === 1) {
                order = "";
            } else if (num === 2) {
                order = 1;
            }
            this.list = "";
            this.sort = num;
            this.page = 1;
            this.finished = false;
            this.todayRecommendList(order);
        },
        // 切换日历
        updateDailyDate (year, month, day) {
            this.showCalendar = false;
            this.loading = true;
            let time = "";
            if (year && month && day) {
                if (day < 10) {
                    day = "0" + day;
                }
                if (month < 10) {
                    month = "0" + month;
                }
                time = year + "-" + month + "-" + day;
            }
            this.page = 1;
            this.finished = false;
            this.selectTime = time;
            this.current_time = time;
            this.end_time = this.getCurrentTime();
            this.list = [];
            this.historyRecommendList(time);
        },
        // 拼接当前年-月-日
        getCurrentTime () {
            var today = new Date();
            var now = [formatDate(today, "yyyy"), formatDate(today, "MM"), formatDate(today, "dd")];
            var todayNow = now[0] + "-" + now[1] + "-" + now[2];
            return todayNow;
        },
        getCookies (key) {
            return getCookie(key)
        },
        isWeixins () {
            return isWeiXin()
        },
        getAppVs () {
            return getAppV()
        },
        getVersionNotApps () {
            return getVersionNotApp() * 1
        },
        // 环形图
        svgCircle () {
            // svg
            const donutSvgPath = document.querySelectorAll(".donut__svg__path");
            const donutSvgR = document.querySelectorAll(".donut__svg__r");
            for (var m = 0; m < donutSvgPath.length; m++) {
                const svgPath = donutSvgPath[m];
                const svgR = donutSvgR[m];
                const $path = svgPath.getElementsByTagName("circle");
                for (var n = 0; n < $path.length; n++) {
                    const pathCircle = $path[n];
                    const r = (svgPath.offsetWidth * 1 - svgR.offsetWidth * 1) / 2;
                    const cx = svgPath.offsetWidth * 1 / 2;
                    const cy = svgPath.offsetWidth * 1 / 2;
                    pathCircle.setAttribute("r", r);
                    pathCircle.setAttribute("cx", cx);
                    pathCircle.setAttribute("cy", cy);
                    pathCircle.setAttribute("fill", "none");
                    pathCircle.setAttribute("stroke-width", svgR.offsetWidth * 1);
                    // eslint-disable-next-line eqeqeq
                    if (n == 1) {
                        const perimeter = 2 * Math.PI * r;
                        const rangeValue = pathCircle.getAttribute("data-percent") * 1;
                        const radio = perimeter - (rangeValue / 100) * perimeter
                        pathCircle.style.strokeDasharray = pathCircle.style.strokeDashoffset = perimeter;
                        pathCircle.style.transition = "stroke-dashoffset 600ms ease-in-out";
                        pathCircle.style.strokeDashoffset = radio;
                    }
                }
            }
        },
        // 模型详情页
        goDataModelDetail (item) {
            const detailUrl = process.env.VUE_APP_H5_DOMAIN + '/page/datamodel?type=15&schedule_id=' + item.schedule_id;
            if (isJHApp()) {
                jsbridg.goWebview({
                    url: detailUrl,
                    jumptype: 2
                });
            } else {
                window.open(detailUrl);
            }
        },
        // 跳转模型购买页
        goPay (renewals) {
            var iosNeedLogin = urlQuery("ios_need_login") * 1 || 0;
            if ((isJHAppios() && getAppV() >= 342) || (isHiscores() && !iosNeedLogin)) {
                // ios V>=342
                // hiscores 不强制登录
            } else if (iosNeedLogin) {
                if (this.noLogin) {
                    doLogin();
                    return;
                }
            }
            // // ios商城包自动续费已开通
            if (this.onlineIsAuto && !isStorepack()) {
                Dialog.alert({
                    title: '温馨提示',
                    message: '您已开通了自动续费功能，需要到苹果设备上取消续费后才能再次购买哦~ 取消方法：通过手机【设置】进入【iTunes Store与App Store】>>选择【Apple ID】>>点击【查看Apple ID】>>在账户设置页面点击【订阅管理】>>取消即嗨大数据报告的订阅即可。',
                    confirmButtonText: '我知道了',
                    confirmButtonColor: '#646566'
                }).then(() => {
                    // on close
                });
                return;
            }
            let payUrl = ""
            if (isJHAppios() || !isJHApp()) {
                payUrl = process.env.VUE_APP_H5_DOMAIN + '/page/new_pay?ordertype=pay_data&type=15&src=' + urlQuery("src");
            } else {
                payUrl = process.env.VUE_APP_DOMAIN + '/user/payment?type=15&src=' + urlQuery("src");
            }
            if (renewals) {
                payUrl += "&renewals=1"
            }
            // this.$router.push({
            //     path: url,
            //     query: {
            //         type: 15,
            //         ordertype: 'pay_data'
            //     }
            // })
            if (isJHApp()) {
                // jsbridg.goWebview({
                //     url: payUrl,
                //     jumptype: 2
                // });
                // this.$router.push(payUrl)
                window.location.href = payUrl
            } else {
                window.open(payUrl);
            }
        }
    }
}
</script>

<style lang="less">
@import url("../../assets/css/_discovery.min.css");
.placehodler{
    width: 100%;
    height: 50px;
}
.bigDataDark{
    min-height: 100vh;
    background-color: #191919;
    .daily-pro{
        background-color: #191919;
    }
    .ai-tab{
        background-color: #191919;
        border-color: #2f2f2f;
        div{
            color: #d3d3d3;
        }
    }
    .cold-summary{
        background-color: #232323;
        .summary-txt{
            color: #d3d3d3
        }
        .summary-btn div{
            background-color: #232323;
        }
    }
    .daily-find .daily-no-find{
        background: url('../../assets/img/datamodel/emptyDark.png');
        background-size: contain;
    }
    .daily-list.bg1{
        background-color: #191919;
    }
    .daily-package{
        .package-dec{
            background-color: transparent;
            border-color: #2f2f2f;
            .match-team-result{
                .team-name{
                    color: #d3d3d3;
                }
                .match-vs-odds{
                    color: #d3d3d3;
                }
            }
            .package-data{
                .packages{
                    color: #d3d3d3;
                }
                .package-charts span{
                    color: #d3d3d3
                }
            }
        }
    }
    .daily-calendar .matchs-num{
        color: #d6d6d6;
    }
    .calendar-plugin{
        background-color: #191919;
        .calendar-title{
            background-color: #232323;
            border-color: #2f2f2f;
            li{
                color: #d3d3d3;
            }
        }
        .calendar-content .calendar-date{
            color: #d3d3d3;
        }
        .calendar-nav{
            color: #a6a6a6;
            .close{
                color: #d3d3d3
            }
        }
    }
}
</style>
